module.exports = __webpack_public_path__ + "assets/img/pt-5249efcc.png";